import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { AIMedia, UploadTypes } from '../../@types';

type Payload = {
  name: string;
  type: UploadTypes;
};

const searchAiMedia = async (payload: Payload): Promise<AIMedia[]> => {
  const res = await axiosInstance.post('/api/stock-gallery/search-ai-media', payload);
  return res.data;
};

export const useSearchAiMedia = () => {
  return useMutation(searchAiMedia, { onSuccess: (data) => data });
};
